var _defs, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3 1.5 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a8f95"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0 48.0 L7.4 13.3 L4.0 4.0 L13.3 7.4 L48.0 42.0Z",
    fill: "url(#bl)",
    stroke: "#4f545a",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3 44.3 L5.4 5.4",
    stroke: "#ffffff",
    strokeWidth: 1.1,
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6 51.4 L51.4 38.6",
    stroke: "#1d1d1d",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7 45.7 L52.8 52.8",
    stroke: "#2c2c2c",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.2,
    cy: 54.2,
    r: 3.6,
    fill: "#1d1d1d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0 42.0 L50.7 7.4 L60.0 4.0 L56.6 13.3 L22.0 48.0Z",
    fill: "url(#bl)",
    stroke: "#4f545a",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 44.3 L58.6 5.4",
    stroke: "#ffffff",
    strokeWidth: 1.1,
    opacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 38.6 L25.4 51.4",
    stroke: "#1d1d1d",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 45.7 L11.2 52.8",
    stroke: "#2c2c2c",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.8,
    cy: 54.2,
    r: 3.6,
    fill: "#1d1d1d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrength);
export default __webpack_public_path__ + "static/media/strength.013ce00d401a7b3fe59132c380aac7d9.svg";
export { ForwardRef as ReactComponent };